<div class="wrapper">
  <div class="top-bar">
    <div class="content">
      <span (click)="navigateToLadingPage()">
        <img src="assets/images/icon/refresh.svg" /> {{ languageData.start }}
      </span>
    </div>
    <div>
      <div class="content"></div>
    </div>
    <select
      id="languageList"
      name="languageList"
      (change)="languageChange($event, '')"
      class="select-dropdown"
    >
      <option
        *ngFor="let option of languageOptions"
        [value]="option?.value"
        [selected]="option?.value === language"
      >
        {{ option?.value }}
      </option>
    </select>
  </div>

  <div class="container p-3">
    <div class="d-flex py-2">
      <div class="resolve-text">
        {{ languageData.thankyouText }}
      </div>
    </div>

    <div class="pt-3">
      <div class="trainingBox">
        <p>{{ languageData.trainingMessage }}</p>
        <div class="d-flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="#006bd3"
            aria-hidden="true"
            class="h-5 w-5 mr-2"
            width="22"
          >
            <path
              fill-rule="evenodd"
              d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm14.024-.983a1.125 1.125 0 010 1.966l-5.603 3.113A1.125 1.125 0 019 15.113V8.887c0-.857.921-1.4 1.671-.983l5.603 3.113z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <div class="ps-2 video-link" (click)="navigate('training')">
            {{ languageData.videoLink }}
          </div>
        </div>
      </div>
    </div>

    <div class="mb-5">
      <button
        type="submit"
        class="btn-blue-outline"
        (click)="navigateToLadingPage()"
      >
        {{ languageData.homeButton }}
      </button>
    </div>
  </div>
</div>
